import { UseMutationOptions } from 'react-query';
import MutationKeys from 'hooks/mutations/keys';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

type Input = {
    html: string;
};

const useDirectMailPdfPreview = (mutateOptions: UseMutationOptions<unknown, Error, Input>) =>
    useMutation<Input>(MutationKeys.PREVIEW_DIRECT_MAIL_PDF, CuredApiPaths.DIRECT_MAIL_PDF_PREVIEW, mutateOptions);

export default useDirectMailPdfPreview;
